/**
 * Checks if given action item is enabled
 *
 * @param {string} action
 * @param {BobTVUser} user
 * @param {BobTVUser} currentUser
 * @return {boolean}
 */
export default function itemEnabled(action, user, currentUser) {
    if (user.isAnonymous()) {
        if (['pm', 'revoke', 'profile', 'follow', 'block', 'ban', 'virtual_gift', 'give_xxl'].indexOf(action) !== -1) return false;
    }

	switch (action) {
		case 'pm': return user.pm_enabled !== 0 || currentUser.isAdmin();
		case 'view': return user.online && user.streaming;
		default: return true;
	}
}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserContextMenu/itemEnabled.js